<div class="user-header" *ngIf="isTranslationLoaded">
  <qai-inner-wrap>
    <div class="breadcrumb-container">
      <qai-breadcrumb-list [items]="getBreadcrumbItems()"></qai-breadcrumb-list>
    </div>

    <ng-container *ngIf="isLoading; else content">
      <div class="loading-container">
        <qai-loading size="medium"></qai-loading>
      </div>
    </ng-container>

    <ng-template #content>
      <div class="user-name">
        <span>{{ userName }}</span>
      </div>

      <div class="teams-row">
        <span class="teams-label">{{ 'reportingV2.TEAMS' | transloco }}:</span>
        <qai-badge [label]="memberOfTeams" [shape]="'round'" [kind]="'gray'"></qai-badge>
      </div>

      <qai-item-grid gap="24px" minItemWidth="230px" repeatCount="auto-fit" class="summary-grid">
        <div class="summary-card">
          <div class="card-value">{{ totalAssignments }}</div>
          <div class="card-label">{{ 'reportingV2.TOTAL_ASSIGNMENTS' | transloco }}</div>
        </div>

      <div class="summary-card" *ngIf="totalCertificationAssignments > 0">
          <div
            class="card-value certified"
            [ngClass]="{
              'certified-complete': certifiedAssignments === totalCertificationAssignments,
              'certified-incomplete': certifiedAssignments < totalCertificationAssignments
            }"
          >
            {{ certifiedAssignments }} {{ 'reportingV2.OF_LABEL' | transloco }} {{ totalCertificationAssignments }}
          </div>
          <div class="card-label">{{ 'reportingV2.ASSIGNMENTS_CERTIFIED' | transloco }}</div>
      </div>

        <div class="summary-card">
          <div class="card-value">{{ totalSessions }}</div>
          <div class="card-label">{{ 'reportingV2.TOTAL_SESSIONS' | transloco }}</div>
        </div>

        <div class="summary-card">
          <div class="card-value">{{ hoursSpentPracticing }}</div>
          <div class="card-label">{{ 'reportingV2.HOURS_SPENT_PRACTICING' | transloco }}</div>
        </div>

        <div class="summary-card">
          <div class="card-value">{{ lastLogin || '_' }}</div>
          <div class="card-label">{{ 'reportingV2.LAST_LOGIN' | transloco }}</div>
        </div>
      </qai-item-grid>
    </ng-template>
  </qai-inner-wrap>
</div>